import { logger } from '@src/shared/includes/logger';
import { isEmpty, isUndefined } from 'lodash';

/**
 * abbrNum
 *
 * Abbreviates a number.
 *
 * @param number
 * @param decPlaces
 * @returns {*}
 */
export function abbrNum(number = 0, decPlaces = 0) {
  if (String(number).length > 6 && decPlaces === 0) {
    return abbrNum(number, 1);
  }

  const decimalPlaces = 10 ** decPlaces;
  const abbrev = ['K', 'M', 'B', 'T'];

  for (let i = abbrev.length - 1; i >= 0; i--) {
    const size = 10 ** ((i + 1) * 3);
    if (size <= number) {
      let roundedNumber = Math.round((number * decimalPlaces) / size) / decimalPlaces;
      if (roundedNumber === 1000 && i < abbrev.length - 1) {
        roundedNumber = 1;
        return `${roundedNumber}${abbrev[i + 1]}`;
      }
      return `${roundedNumber}${abbrev[i]}`;
    }
  }

  return number;
}

/**
 * hexToRgb
 *
 * Converts a hex color to an rgb color supports rgba (opacity as well)
 *
 * @param hex
 * @param alpha
 * @returns {string}
 */
export function hexToRgb(hex = '', alpha = 0.0) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  return `rgb(${r}, ${g}, ${b})`;
}

/**
 * parallelFetch
 *
 * Fetches provided requests in parallel.
 *
 * @param requests
 * @returns {Promise<{}>}
 */
export async function parallelFetch(requests = {}) {
  const response = {};

  try {
    if (isEmpty(requests)) {
      return response;
    }

    const promises = Object.keys(requests).map(async (key) => {
      const request = requests[key];

      let result;

      if (!isUndefined(request?.callback)) {
        if (!isUndefined(request?.args)) {
          result = await request?.callback(request?.args);
        } else {
          result = await request?.callback();
        }

        response[key] = result;
      }
    });

    await Promise.all(promises);
  } catch (error) {
    logger.error('includes/functions.js -> parallelFetch()', false, error);
  }

  return response;
}

/**
 * replaceMessagePlaceholders
 *
 * @param obj
 * @param singularName
 * @returns {*|string}
 */
export function replaceMessagePlaceholders(obj, singularName) {
  if (typeof obj === 'string') {
    return obj.replace(/{{singularName}}/g, singularName);
  }
  if (Array.isArray(obj)) {
    return obj.map((item) => {
      return replaceMessagePlaceholders(item, singularName);
    });
  }
  if (typeof obj === 'object' && obj !== null) {
    const result = {};
    Object.keys(obj).forEach((key) => {
      result[key] = replaceMessagePlaceholders(obj[key], singularName);
    });
    return result;
  }
  return obj;
}
